
import Container from "../layouts/Container.vue";
import Home from "../pages/Home.vue";
import StaticPage from "../pages/StaticPage.vue";
import PageNotFound from "../pages/404.vue";
import ErrorPage from "../pages/error.vue";
import EventDetails from "../pages/EventDetails.vue";
import Checkout from "../pages/Checkout.vue";
import Confirmation from "../pages/Confirmation.vue";
import OrderConfirmationRedirect from "../pages/OrderConfirmationRedirect.vue";
import MembeEventHistory from "../pages/MembeEventHistory.vue";
import MembeEventHistoryDetails from "../pages/MembeEventHistoryDetails.vue";


export default [
    {
        path: '/', component: Container,
        children: [
            { path: ':langCode', component: Home },
            { path: ':langCode/page/:type/:code', component: StaticPage },
            { path: ':langCode/error', component: ErrorPage },
			{ path: ':langCode/event/:eventId', component: EventDetails },
            { path: ':langCode/event/:eventId/:eventTitle', component: EventDetails },
            { path: ':langCode/eventpreview', component: EventDetails },
            { path: ':langCode/checkout', component: Checkout },
            { path: ':langCode/preview', component: Checkout },
            { path: ':langCode/confirmation', component: Confirmation }, 
            { path: ':langCode/order_confirmation', component: OrderConfirmationRedirect },  
            {
                path: ':langCode/member/eventhistory', component: MembeEventHistory,
                children: [
                    { path: ':orderNo', component: MembeEventHistoryDetails }
                ]
            },  
            { path: ':langCode/*', component: PageNotFound }
        ]
    }
    , 
    { path: '*', component: PageNotFound }
]